// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__26veo","dragIcon":"Choice_dragIcon__1aqY6","left":"Choice_left__1iihc","input":"Choice_input__2ENgb"};